import { Injectable } from '@angular/core';
import axios from 'axios';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';

import { ApiService } from './api.service';
import { LogService } from "./log.service";
import { ApiResponse, ApplicationFeedback } from '../shared/interfaces/api-response';
import { UserDetails } from '../shared/interfaces/user-details';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  savedUser: Subject<UserDetails> = new Subject<UserDetails>()

  constructor(private apiService: ApiService, 
              private cookieService: CookieService,
              private logger: LogService) { }

  loadSavedUserCookie() {
    let tempUser: UserDetails
    let tempToken: string
    if (this.cookieService.check('savedUser') && this.cookieService.check('token')) {
      tempUser = JSON.parse(this.cookieService.get('savedUser'))
      tempToken = this.cookieService.get('token')
      if (tempUser && tempToken) {
        this.savedUser.next(tempUser)
        axios.defaults.headers.common['Authorization'] = tempToken
        return true
      }
    }
    return false
  }

  async login(username: string, password: string) {
    const user = {
      username: username,
      password: password
    }
    // TODO: log login attempt clientip, clientapp, server

    const response: ApiResponse = await this.apiService.post<UserDetails>('/api/account/authenticate', user)

    if (response.success && response.body.success) {
      await this.logger.info('successful login: ' + username);
      this.saveCredentials(user.username, user.password, response.body.IsSuperUser);
      return new ApplicationFeedback({success: true, message: 'Login successful'});
    }
    else {
      await this.logger.info('failed login: ' + username);
      return new ApplicationFeedback({success: false, message: 'Login failed'}); 
    }
  }

  private saveCredentials(username: string, password: string, isSuperUser: boolean) {
    const token = btoa(username + ':' + password);
    const tempUser: UserDetails = {
      username: username,
      isUserLoggedIn: true,
      isSuperUser: isSuperUser
    }
    axios.defaults.headers.common['Authorization'] = token
    this.savedUser.next(tempUser)
    this.cookieService.set(
      'token',
      token,
      {
        expires: 3,
        secure: true,
        sameSite: 'Strict'
      }
    )
    this.cookieService.set(
      'savedUser',
      JSON.stringify(tempUser),
      {
        expires: 3,
        secure: true,
        sameSite: 'Strict'
      }
    )
  }

  removeCredentials() {
    this.savedUser.next({
      username: '',
      isUserLoggedIn: false,
      isSuperUser: false
    })
    this.cookieService.deleteAll()
    axios.defaults.headers.common['Authorization'] = ''
  }
}
